"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateBankLabel = exports["default"] = void 0;
/* eslint-disable default-param-last */
var generateBankLabel = function generateBankLabel() {
  var textToAppend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var institution = arguments.length > 1 ? arguments[1] : undefined;
  return textToAppend !== '' && institution ? "".concat(institution, " - ").concat(textToAppend) : textToAppend;
};
exports.generateBankLabel = generateBankLabel;
var _default = generateBankLabel;
exports["default"] = _default;
